import axios from "axios";
import router from "@/router";
import Endpoint from "../../constant/endpoint";

const state = {
  loading: false,
  error: {},
  data: {},
  userData:{},
  token: "",
  accessUsername: localStorage.getItem('accessUsername') || '',
  accessToken: localStorage.getItem('accessToken') || '',
  isLoginSuccess: false,
    
};

const getters = {
  // foods: state => state.foods
  getterError: (state) => {
      return state.error;
  },
};

const actions = {
  // action
  login(context, { username, password }) {
    context.commit("LOADING", true);
    const url = Endpoint.usersLogin();
    axios
      .post(url, {
        username,
        password,
      })
      .then((res) => {
        // login success
        context.commit("LOGIN_SUCCESS", { data: res.data });
      })
      .catch((error) => {
        // login fail
        context.commit("LOGIN_ERROR", { error });
      })
      .finally(() => {
        context.commit("LOADING", false);
      });
  },
  async register(
    context,
    {
      username,
      password,
      firstName,
      lastName,
      // nickname,
      email,
      // address,
      // telephone,
      // gender,
      // city,
      // dayOfBirth,
    }
  ) {
    context.commit("LOADING", true);
    const url = Endpoint.usersRegister();
    await axios
      .post(
        url,
        {
          username,
          password,
          firstName,
          lastName,
          // nickname,
          email,
          // address,
          // telephone,
          // gender,
          // city,
          // dayOfBirth,
        },
        { "content-type": "application/json" }
      )
      .then((res) => {
        // reg success
        if (res.data) {
          console.log("register successful");
          context.commit("LOGIN_ERROR", {
            status: 201,
            username,
            message: "login successful",
          });
        }
      })
      .catch((error) => {
        // reg fail
        context.commit("LOGIN_ERROR", { error });
      })
      .finally(() => {
        context.commit("LOADING", false);
      });
  },
};

const mutations = {
  // mutations
  LOGIN_SUCCESS(state, payload) {
    localStorage.setItem("accessUsername", payload.data.user_name);
    localStorage.setItem("accessToken", payload.data.access_token);
    state.data = payload.data;
    state.isLoginSuccess = true;
  },
  LOGIN_ERROR(state, payload) {
    state.error = payload.error;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
  REGISTER_SUCCESS(state, payload){
    state.userData = payload.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
